import gql from 'graphql-tag';

export default gql`
  mutation updateSchoolProfiles($input: updateHubsSchoolProfilesInput!) {
    updateHubsSchoolProfiles(input: $input) {
      viewer {
        id
        hubsSchoolProfiles {
          img
          type
          body
          headline
          quote
          product_id
        }
      }
    }
  }
`;
